<template>
  <div class="phone-product">
    <el-collapse accordion>
      <el-collapse-item
        v-for="(item, index) in menuGroup"
        :key="index"
        :name="index.toString()"
        class="coll-item"
      >
        <template slot="title">
          <div class="text">
            {{ item.title }}
          </div>
        </template>
        <template>
          <div
            v-for="(children, j) in item.list"
            :key="j"
            class="phone-product_property"
          >
            <div
              class="cup property-title"
              @click="goDetails(children)"
            >
              {{ children.label }}
            </div>
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'MproductS',
  data() {
    return {
      menuGroup: [
        {
          title: '企业介绍',
          list: [
            { label: '关于我们', path: 'https://www.gwlaser.tech/aboutUs' },
            { label: '新闻中心', path: 'https://www.gwlaser.tech/aboutUs/news' },
            { label: '市场活动', path: 'https://www.gwlaser.tech/aboutUs/market' },
            { label: '人才招聘', path: 'https://www.gwlaser.tech/aboutUs/recruit' },
            { label: '政策&标准', path: 'https://www.gwlaser.tech/aboutUs/policy' },
            { label: '联系我们', path: 'https://www.gwlaser.tech/support/contactUs' },
          ],
        },
        {
          title: '解决方案',
          list: [],
        },
        {
          title: '核心技术',
          list: [
            { path: 'https://www.gwlaser.tech/technologies/innovate', label: '我们的技术创新' },
            { path: 'https://www.gwlaser.tech/technologies/fiberLaser', label: '什么是光纤激光器' },
            { path: 'https://www.gwlaser.tech/technologies/highEfficiency', label: '976nm高效率泵浦' },
            { path: 'https://www.gwlaser.tech/technologies/multipleBeam', label: '多光束可调输出' },
            { path: 'https://www.gwlaser.tech/technologies/laserMode', label: '激光模态输出控制' },
            { path: 'https://www.gwlaser.tech/technologies/energyOutput', label: '能量输出闭环控制' },
            { path: 'https://www.gwlaser.tech/technologies/directCool', label: '空调直冷技术' },
            { path: 'https://www.gwlaser.tech/technologies/internet', label: '物联网控制' },
          ],
        },
        {
          title: '新闻中心',
          list: [
            { label: '技术文章', path: 'https://www.gwlaser.tech/aboutUs/news?index=0' },
            { label: '行业新闻', path: 'https://www.gwlaser.tech/aboutUs/news?index=1' },
            { label: '市场活动', path: 'https://www.gwlaser.tech/aboutUs/news?index=2' },
          ],
        },
      ],
    }
  },
  methods: {
    goDetails(item) {
      if (item.path) {
        // http/https 外链：新窗口打开
        if (/^https?:\/\//i.test(item.path)) {
          window.open(item.path, '_blank')
        } else {
          // 内部路由：使用 router 跳转
          this.$router.push({
            path: item.path,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.phone-product {
  margin-top: 20px;
  .el-collapse {
    border: none;
  }
  :deep(.el-collapse-item:last-child) {
    display: none;
  }
  :deep(.el-collapse-item__header) {
    background: none;
    color: #fff;
    border-bottom: none;
    font-size: 14px;
    height: 50px;
    display: flex;
    font-weight: 600;
    justify-content: flex-start !important;
    border-bottom: 1px solid #fff;
    border-color: rgba(#fff, 0.3);
  }
  :deep(.el-collapse-item__wrap) {
    padding-top: 10px;
    background: none;
    border-bottom: none;
  }
  :deep(.el-collapse-item__content) {
    padding-bottom: 5px;
  }

  &_property {
    font-size: 14px;
    color: #fff;
    margin-top: 5px;
    .property-title {
      padding: 0px 0 5px 20px !important;
    }
  }
}
</style>